export default function ($scope, $location, $window, AuthenticationService, FlashService) {
    //AuthenticationService.ClearCredentials();

    if(GetData().currentUser)
        $location.path('/account');

    $scope.menu = function() {
        $('html').toggleClass("nav-open");
    };
    $scope.year = new Date().getFullYear();


    setTimeout(function(){
        if($location.search().expired){
            FlashService.Error('ERROR_LINK_EXPIRED');

            $location.search('expired', null);
        }
    }, 100);


    $scope.login = function () {
        $scope.dataLoading = true;
        AuthenticationService.Login($scope.username, $scope.password, function(response) {
            if(response.status == "200") {
                AuthenticationService.SetCredentials(response.data.access_token, function(){
                    $location.path('/loading');
                });

            } else {
                FlashService.Error('ERROR_USSER_PASSWORD_INCORRECT')
                $scope.dataLoading = false;

            }
        });
    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/login/controller.js
 **/